import React from "react";
import {Svg, Path, G} from "react-primitives-svg";
import PropTypes from "prop-types";
import {svgSize} from "../helpers/svg";

export default function Icon({fill, height, width, ...rest}) {
  return (
    <Svg
      {...rest}
      {...svgSize(height, width)}
      viewBox="0 0 19 34"
      preserveAspectRatio="xMidYMid meet">
      <G fill={fill} id="Mobile" fillRule="evenodd">
        <Path
          d="M3.99738889,27.1843939 L6.02511111,22.7881818 C6.29216667,22.6810606 6.55922222,22.5739394 6.77244444,22.4127273 L6.77244444,22.3586364 C7.35933333,21.9301515 7.67916667,21.2333333 7.733,20.4283333 L7.733,19.570303 L12.4291667,19.6774242 L18.6189444,32.170303 L14.9371667,34.0465152 L10.0277778,24.1807576 L7.41316667,29.5962121 L3.62477778,34.0465152 L0.423277778,31.4724242 L3.99844444,27.1833333 L3.99738889,27.1843939 Z M11.0411111,10.295303 C12.1610556,11.2063636 12.5885556,12.3868182 12.5347222,13.7804545 L12.4281111,18.8734848 L7.73194444,18.7663636 L7.78577778,14.2089394 L6.98566667,15.4424242 L6.87905556,20.375303 C6.87905556,20.965 6.66583333,21.4475758 6.29216667,21.7159091 C5.9185,21.9842424 5.54483333,22.1443939 4.95794444,22.1443939 C4.37105556,22.1443939 3.99738889,21.9301515 3.62372222,21.6618182 C3.30388889,21.3934848 3.08961111,20.9109091 3.08961111,20.3212121 L3.19622222,14.5843939 L5.757,10.0269697 C6.13066667,9.49030303 6.82416667,9.2230303 7.67811111,9.2230303 C8.90572222,9.2230303 10.0795,9.49136364 11.0400556,10.295303 L11.0411111,10.295303 Z M5.75911111,4.34318182 C5.81294444,1.98439394 7.78683333,0.0540909091 10.1343889,0.107121212 C12.5357778,0.161212121 14.4568889,2.09151515 14.4030556,4.50333333 C14.3492222,6.86212121 12.3753333,8.79242424 10.0277778,8.73939394 C7.62638889,8.68530303 5.70527778,6.7019697 5.75911111,4.34318182 Z M13.1765,18.2837879 L13.2292778,14.4231818 L15.7900556,14.4762121 C16.3769444,14.4762121 16.8572222,14.7445455 17.1242778,15.0659091 C17.3913333,15.4943939 17.5507222,15.8698485 17.5507222,16.4595455 C17.5507222,16.9962121 17.3902778,17.424697 17.0704444,17.8001515 C16.8033889,18.1215152 16.3231111,18.3368182 15.7362222,18.3368182 L13.1754444,18.2837879 L13.1765,18.2837879 Z"
          id="Shape"
        />
      </G>
    </Svg>
  );
}

Icon.propTypes = {
  fill: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Icon.displayName = "Icons.Walking";
